<template>
  <div class="header-container h6-mb h7 display-flex justify-between align-center">
    <span class="mr1 ml1 display-flex">
      <bh-icon icon="nav" class="pointer f2-5 show-mb-block text-violet" @output="navbarToggle"/>
      <router-link to="/" class="display-flex align-center">
        <span class="mr1 ml1 ma0">
          <img class="logo" alt="logo" src="/assets/techolution_logo.png"/>
        </span>
        <span class="title f1-6 text-violet none-mb">Techolution</span>
      </router-link>
    </span>
    <div class="display-flex justify-end mr2 mr0-mb w50p">
      <bh-search-bar v-if="enableSearch" class="h5 none show-dk-flex w30 mr2" @search="onSearch($event)" :placeholder="searchPlaceholder" />
      <bh-button v-if="!hideFeedbackButton" btnClass="display-flex bg-violet text-white border-none br0-5 f1-5 f1-3-mb minw30 pa1" @output="toggleModal">
        <bh-icon icon="feedback" class="mr1"/>
        Submit Feedback
      </bh-button>
      <div class="display-flex justify-center w35p">
        <div class="display-flex justify-between align-center w100p pointer pos-rel" id="anchorUser" @click.stop="toggleMenu">
          <bh-icon icon="user" class="mr1 mt0-5 f2-5 ml2 text-violet b1 border-violet br50p w4 h4 lh3" />
          <span class="text-light-grey display-flex align-center axiforma-bold f1-3 text-left hide-mb">{{ fullName }}</span>
          <bh-icon icon="play-down" class="pr1-2 ml1 hide-mb f-5 text-violet inline"/>
        </div>
          <bh-menu data-app class="pos-abs top5 right--40 right-25-mb minw35" :value="showMenu" v-click-outside="closeMenu">
            <div class="bg-white minw35"></div>
            <div class="text-violet f1-5">Logged in as</div>
            <div class="text-light-grey axiforma-bold f1-3 pt1 pb2">{{ email }}</div>
             <router-link class="w100p h5 display-flex justify-center align-center bg-white border-top-violet text-light-grey text-hover-violet f1-5 minw30 pa1" to="/change-password">
             Change password
             </router-link>
            <bh-button btnClass="w100p h5 display-flex justify-center align-center bg-violet text-white border-none f1-5 minw30 pa1" @output="logout">Logout</bh-button>
          </bh-menu>
      </div>
    </div>
    <bh-modal-overlay v-if="!hideFeedbackButton" :showModal="showModal" @modal-close="toggleModal" disableOutSideClick>
      <bh-feedback @close-model="toggleModal"/>
    </bh-modal-overlay>
  </div>
</template>

<script>
import { Feedback } from '@/components'
import { mapActions, mapGetters } from 'vuex'

import cookies from '@/services/cookies'
import { setIdleTimeout, removeIdleListeners } from '@/services/idle-time'

export default {
  name: 'bh-header',
  components: {
    'bh-feedback': Feedback
  },
  computed: {
    ...mapGetters(['enableSearch', 'hideFeedbackButton', 'isNavBarClose', 'idleTime']),
    ...mapGetters('common/user', ['email', 'fullName'])
  },
  data() {
    return {
      searchPlaceholder: 'Search by P.Name, P.ID, P.Location',
      showModal: false,
      showMenu: false
    }
  },
  mounted() {
    setIdleTimeout(this.idleTime, this.onIdle, this.onUnIdle)
  },
  methods: {
    ...mapActions(['setNavBarOpenStatus']),
    onSearch(ev) {},
    toggleModal() {
      this.showModal = !this.showModal
    },
    navbarToggle() {
      this.setNavBarOpenStatus(!this.isNavBarClose)
    },
    logout() {
      cookies.delete('jwt_token')
      if (this.$socket?.connected) this.$socket.disconnect()
      this.$router.push('/login')
      removeIdleListeners()
    },
    toggleMenu() {
      this.showMenu = !this.showMenu
    },
    closeMenu() {
      this.showMenu = false
    },
    onIdle() {
      this.logout()
      alert('You\'re idle for a long time, session was expired. Please login again.')
    },
    onUnIdle() {
      // console.log('On Un Idle stuff can be done here')
    }
  },
  destroyed() {
    removeIdleListeners()
  }
}
</script>

<style scoped>
.header-container {
  box-shadow: 0px 3px 6px #0a4b6d29;
  z-index: 10001;
  position: fixed;
  background: white;
  width: 100%;
}

.logo {
  height: 4rem;
  width: 4rem;
}

.w0 {
  width: 0;
}
</style>
